import { Action } from '@ngrx/store';

export class MetaActionTypes {
    static LOGOUT = '[App] logout';
  }

export class Logout implements Action {
    readonly type = MetaActionTypes.LOGOUT;
}
